import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { CommonService } from '@frontend/promo-homewidget';
import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsTooltipModule } from '@frontend/ui/tooltip';
import { NavigationService } from '@frontend/vanilla/core';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { OnClickWTDirective } from '../../../../../common/web-tracking/onclick-web-tracking.directive';
import { WebAnalyticModel } from '../../../../../common/web-tracking/web-analytic.model';
import { CommonEventService } from '../../events/common-event.service';
import { ResultsPrize } from '../../models/results/results-prize';
import { TargetPromoState, commonContentMessages } from '../../store/target-promotion.selectors';

interface ResultsPrizeViewModel {
    resultsPrize: ResultsPrize;
    showCheckButton: boolean;
    commonContentMessages: { [key: string]: string };
    webAnalytic: WebAnalyticModel;
}

@Component({
    selector: 'tp-results-prize',
    templateUrl: './results-prize.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, DynamicHtmlDirective, OnClickWTDirective, IconCustomComponent, DsTooltipModule, DsButtonIcon, NgTemplateOutlet],
})
export class ResultsPrizeComponent implements OnChanges {
    @Input() resultsPrize: ResultsPrize;
    @Input() showCheckButton: boolean;

    vm$: Observable<ResultsPrizeViewModel>;
    dsComponents: DSComponents;

    constructor(
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
        private commonService: CommonService,
        private commonEventService: CommonEventService,
        private navService: NavigationService,
        private designSystemHelperService: DesignSystemHelperService,
    ) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }

    ngOnChanges() {
        this.vm$ = combineLatest([this.store.select(commonContentMessages), this.commonEventService.getWAModel()]).pipe(
            map(([commonContentMessages, webAnalytic]) => {
                return {
                    resultsPrize: this.resultsPrize,
                    showCheckButton: this.showCheckButton,
                    commonContentMessages: commonContentMessages ?? {},
                    webAnalytic,
                };
            }),
        );
    }

    checkButtonClick() {
        if (this.resultsPrize?.checkPromoLink?.url) {
            this.navService.goTo(this.resultsPrize?.checkPromoLink?.url);
        } else {
            this.commonService.goToOverviewPage();
        }
    }
}
